import { SimpleTable } from 'Foundation/Common/SimpleTable';
import { useUserData } from 'Foundation/User/UserContext';
import { useEffect, useState } from 'react';
import { ISimpleInputTableItem, SimpleInputTable } from 'Foundation/Common/SimpleInputTable';
import { Card, ExpandableCard } from '@lmig/lmds-react-card';
import { Heading } from '@lmig/lmds-react-typography';

export function AgencyInfo() {
  const { userData } = useUserData();
  const [primaryAgency, setPrimaryAgency] = useState<{ name: string; value: string | boolean | undefined, options?:string[] }[]>([]);
  const [newAgency, setNewAgency] = useState<{ name: string; value: string | boolean | undefined, options?:string[] }[]>([]);
  const plTiers: string[] =['Advantage', 'Advantage Plus', 'Elite', 'Partner Plus', 'Plus', 'VIP', 'Partner', 'Launch', 'Launch Plus'];
  const scTiers: string[] =['Advantage', 'Catalyst', 'Elite', 'Launch', 'Plus', 'Partner', 'Launch', 'Launch Plus'];  
  const plRoles: string[] = ['PRINC','PROD','CSR'];
  const scRoles: string[] = ['ADMIN','CLM','CSR', 'DEPTMNGR', 'MKTMNGR', 'MISC', 'OTH', 'PRINC', 'PROD', 'COMP', 'TPA', 'UNK'];
  useEffect(() => {
    if (userData && userData.isBL()) 
                              setPrimaryAgency([
                                { name: 'Agency Number', value: userData.selectedStatCodeData.SubStat },
                                {
                                  name: 'Master Agency',
                                  value:
                                    userData.selectedStatCodeData.Master === userData.selectedStatCodeData.SubStat
                                      ? 'Yes'
                                      : 'No',
                                },
                                { name: 'Final Tier', value: userData.selectedStatCodeData.Tier, options:scTiers},
                                { name: 'Role', value: userData.selectedStatCodeData.Role, options:scRoles },
                                {
                                  name: 'Confidential Access',
                                  value: userData.selectedStatCodeData.OMConfidential,
                                },
                                { name: 'Region', value: userData.selectedStatCodeData.Region },
                                {
                                  name: 'Primary Contact Name',
                                  value: userData.selectedStatCodeData.PrimaryContactName,
                                },
                                {
                                  name: 'Primary Contact Email',
                                  value: userData.selectedStatCodeData.PrimaryContactEmail,
                                },
                                {
                                  name: 'Servicing Type Code',
                                  value: userData.selectedStatCodeData.AgencyServicingTypeCode,
                                },
                              ]);
    else if (userData && userData.isPL())
      setPrimaryAgency([
                                { name: 'Master Agency Name', value: userData.selectedStatCodeData.AgencyName },
                                { name: 'Master Agency Number', value: userData.selectedStatCodeData.Master },
                                { name: 'Sub Agency Number', value: userData.selectedStatCodeData.SubStat },
                                { name: 'Trending Tier', value: userData.selectedStatCodeData.TrendingTier },
                                { name: 'Final Tier', value: userData.selectedStatCodeData.Tier, options: plTiers },
                                { name: 'Role', value: userData.selectedStatCodeData.Role, options: plRoles },
                                {
                                  name: 'Is Ignite Rewards Manager',
                                  value: userData.selectedStatCodeData.IsRewardsManager,
                                },
                                { name: 'Confidential Access', value: userData.selectedStatCodeData.OMConfidential},
                                {
                                  name: 'Sub Agency Confidential',
                                  value: userData.selectedStatCodeData.SubStatConfidential,
                                },
                                {
                                  name: 'Access to Master Agency',
                                  value: (userData.selectedStatCodeData.SubStat === userData.selectedStatCodeData.Master).toString() ,
                                },
                                { name: 'Region', value: userData.selectedStatCodeData.Region},
                                {
                                  name: 'Primary Contact Name',
                                  value: userData.selectedStatCodeData.PrimaryContactName,
                                },
                                {
                                  name: 'Primary Contact Email',
                                  value: userData.selectedStatCodeData.PrimaryContactEmail,
                                },
                                {
                                  name: 'Servicing Type Code',
                                  value: userData.selectedStatCodeData.AgencyServicingTypeCode,
                                },
                              ])
                              }, [userData]);                          

  const updateAgencyInfo = async (isReset = false) => {
    await fetch('/api/sitecore/PortalUserUpdateAsync/SetUserInfoAsync', {
        method: 'POST',
        body: new URLSearchParams({ 
          selectedSub: userData?.selectedStatCodeData.SubStat ?? "", 
          selectedMaster: userData?.selectedStatCodeData.Master ?? "", 
          tier: newAgency.find(x => x.name === 'Final Tier')?.value as string, 
          role: newAgency.find(x => x.name === 'Role')?.value as string, 
          confAccess: newAgency.find(x => x.name === 'Confidential Access')?.value as string,
          isReset: isReset ? "true" : "false"
    })
  })
}
  const updatePrimaryAgency = (table: ISimpleInputTableItem[]) => {
    setNewAgency(table);
  }
  return (
    <>
      {userData && (
              <ExpandableCard cardTitle={<Heading type="h4-light">Primary Agency</Heading>}>
                    <div>
                      {userData.isMockingAgent ? (
                                    <>
                                      <SimpleInputTable
                                        tableObject={primaryAgency}
                                        onSubmit={() => updateAgencyInfo()}
                                        onUpdate={(table: ISimpleInputTableItem[]) => updatePrimaryAgency(table)}
                                        onReset={() => updateAgencyInfo(true)}
                                        disabledFields={['Master Agency Name','Agency Number', 'Master Agency', 'Master Agency Number', 'Sub Agency Number', 'Trending Tier', 'Is Ignite Rewards Manager', 'Primary Contact Name', 'Primary Contact Email', 'Servicing Type Code', 'Access to Master Agency', 'Region', 'Sub Agency Confidential']}
                                      />
                                    </>
                                  ) : (
                                    <SimpleTable
                        tableObject={
                          primaryAgency
                        }
                        nameProp="name"
                        valueProp="value"
                      />
                                  )}
                      
                    </div></ExpandableCard>
      )}
    </>
  );
}
